import React, { useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  LineController,
  BarController,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

import { Chart } from "react-chartjs-2";
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  LineController,
  BarController,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const labels = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];

const ChartComponent = ({data}) => {
  const paindxArr = new Array(12).fill();
  const cdindxArr = new Array(12).fill();
  for(let i = 0; i < paindxArr.length; i++) {
    paindxArr[i] = parseFloat(data[`${i + 1}_PAINDEX`]).toFixed(2);
    cdindxArr[i] = parseFloat(data[`${i + 1}_CDINDEX`] ? data[`${i + 1}_CDINDEX`] : 0).toFixed(2);
  }
  const ChartData = {
    labels : labels
    ,
    datasets: [
      {
        yAxisID: "y1",
        type: 'bar',
        label: '파강 Index',
        beginAtZero: true,
        position: "left",
        data: paindxArr,
        borderColor: 'rgb(53, 162, 235)',
        backgroundColor: 'rgba(53, 162, 235, 0.5)',
        datalabels: {
          align: "start",
        }
      },
      {
        yAxisID: "y2",
        type: "line",
        label: 'CD Index',
        beginAtZero: true,
        position: "left",
        data: cdindxArr,
        borderColor: 'rgb(102, 0, 51)',
        backgroundColor: 'rgba(179, 0, 80, 0.5)',
        datalabels: {
          align: "end",
        }
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    scales: {
      x: {
        ticks: {
          font: {
            size: 15,
            weight: 'bold'
          }
        }
      },
      y1: {
        position: 'left',
        title: {
          text: '파강 Index (kgf)',
          display: true,
          font: {
            size: 15,
            weight: 'bold'
          }
          
        },
        ticks: {
          font: {
            size: 15,
            weight: 'bold'
          }
        },
        min: 0,
        stepSize: 0.5,
        max: 2.5
      },
      y2: {
        position: 'right',
        title: {
          text: 'CD Index (kgf)',
          display: true,
          ticks: {
            minRotation: 180,
            maxRotation: 180,
          },
          // minRotation: 180,
            // maxRotation: 180,
          font: {
            size: 15,
            weight: 'bold'
          }
        },
        min: 0,
        stepSize: 2,
        max: 25.0,
        ticks: {
          font: {
            size: 14,
            weight: 'bold'
          }
        },
      }
    },
    layout: {
      padding: {
        top: 20,
        bottom: 5,
        left: 20,
        right: 20
      }
    },
    barThickness: 20,
    plugins: {
      legend: {
        labels: {
          font: {
            size: "14",
            weight: 'bold'
          }
        },
        position: 'bottom',
      },
      title: {
        display: false,
        position: 'left',
      },
      datalabels: {
        formatter: function (value) {
          return value;
         },
        font: {
          size: "15",
          weight: 'bold'
        },
        display: true,
        color: "black",
        anchor: "end",
      }
    },
  };
  // useEffect(() => {

  // }, [])
  const m = matchMedia("screen and (max-width: 1024px)");
  return(
    <div className="flex my-1 max-w-fit">
      <MachineName name={`PM${data.HOGIXX ?? ""}`}/>
      <Chart className="bg-white" height={ m.matches ? "220vh" : "300vh"} width={m.matches ? "1500vm" : "1770vm"} options={options} data={ChartData} plugins={[ChartDataLabels]}/>
    </div>
  )
}

const MachineName = ({name}) => {
  return (
    <div className="[writing-mode:vertical-lr] font-bold text-4xl text-white bg-blue-400" style={{ textOrientation: "upright" }}>
      {name}
    </div>
  )
}

export default ChartComponent;